import React, { useState } from 'react';
import Pagination from '@mui/material/Pagination';
import BtButton from '../bt-button/bt-button';
import './pagination-with-goto.scss';

interface PaginationWithGoToProps {
    count: number;
    page: number;
    onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
    showGoTo?: boolean;
    color?: 'primary' | 'secondary' | 'standard';
    size?: 'small' | 'medium' | 'large';
    shape?: 'circular' | 'rounded';
    variant?: 'text' | 'outlined';
    t: any;
}

export default function PaginationWithGoTo({
    count,
    page,
    onChange,
    showGoTo = true,
    color = 'standard',
    size = 'medium',
    shape = 'circular',
    variant = 'text',
    t
}: PaginationWithGoToProps) {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow numbers
        if (value === '' || /^\d+$/.test(value)) {
            setInputValue(value);
        }
    };

    const handleGoToPage = () => {
        // Ignore empty input
        if (inputValue === '') {
            return;
        }

        const pageNum = parseInt(inputValue, 10);

        // Ignore invalid numbers
        if (isNaN(pageNum)) {
            setInputValue('');
            return;
        }

        // Clamp to nearest valid page
        let targetPage = pageNum;
        if (pageNum < 1) {
            targetPage = 1;
        } else if (pageNum > count) {
            targetPage = count;
        }

        // Ignore if already on the target page
        if (targetPage === page) {
            setInputValue('');
            return;
        }

        // Navigate to target page
        onChange(null as any, targetPage);
        setInputValue('');
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleGoToPage();
        }
    };

    return (
        <div className="pagination-with-goto-container">
            <Pagination
                count={count}
                page={page}
                onChange={onChange}
                color={color}
                size={size}
                shape={shape}
                variant={variant}
            />

            {showGoTo && (
                <div className="goto-page-controls">
                    <div className="goto-input-wrapper">
                        <input
                            key="goto-page-input"
                            type="text"
                            className="goto-page-input"
                            placeholder={`1-${count}`}
                            value={inputValue}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyPress}
                        />
                    </div>
                    <BtButton
                        color="white"
                        size="xxs"
                        onClick={handleGoToPage}
                        disabled={!inputValue}
                    >
                        {t('goTo', 'Gå')}
                    </BtButton>
                </div>
            )}
        </div>
    );
}

